// SujetoTipoIdentificacionList.jsx
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../../controls/DashboardLayout";
import DashboardNavbar from "../../../controls/DashboardNavbar";
import MDBox from "../../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../../controls/MDTypography";
import ManualAyuda from "../../../controls/ManualAyuda";
import MDBadge from "../../../controls/MDBadge";
import MDButton from "../../../controls/MDButton";
import DataTable from "../../../controls/Tables/DataTable";
import { BuildingFillAdd, PencilSquare, Trash } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import { getData, deleteData } from "../../../Utils/Http/api";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function SujetoTipoIdentificacionList() {
	const [columns, setColumns] = useState([]);
	const [rows, setRows] = useState([]);
	const [error, setError] = useState(null);
	const navigate = useNavigate();
	const [openDelete, setOpenDelete] = useState(false);
	const [deleteId, setDeleteId] = useState(null);
	const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
	const [refreshKey, setRefreshKey] = useState(0);
	const [deleting, setDeleting] = useState(false);

	const handleAdd = () => navigate("/SujetoTipoIdentificacionAdd");

	useEffect(() => {
		fetchData();
	}, []);

	const mapRows = (list) =>
		list.map((item) => ({
			id: item.idSujetoTipoIdentificacion,
			tipoIdentificacion: (
				<MDTypography variant="caption" color="text" fontWeight="medium">
					{item.tipoIdentificacion}
				</MDTypography>
			),
			activo: (
				<MDBox ml={-1}>
					{item.activo ? (
						<MDBadge badgeContent="activo" color="success" variant="gradient" size="sm" />
					) : (
						<MDBadge badgeContent="desactivado" color="error" variant="gradient" size="sm" />
					)}
				</MDBox>
			),
			action: (
				<MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
					<MDTypography variant="caption" color="text" fontWeight="medium">
						<Link to={`../SujetoTipoIdentificacionEdit/${item.idSujetoTipoIdentificacion}`}>
							<MDButton variant="text" color="dark">
								<PencilSquare color="blue" />
							</MDButton>
						</Link>
					</MDTypography>
					<MDTypography variant="caption" color="text" fontWeight="medium">
						<MDButton variant="text" color="dark" onClick={() => handleAskDelete(item.idSujetoTipoIdentificacion)} disabled={deleting}>
							<Trash color="red" />
						</MDButton>
					</MDTypography>
				</MDBox>
			),
		}));

	const fetchData = async () => {
		try {
			const response = await getData("/SujetoTipoIdentificacionListar");
			const list = Array.isArray(response?.value) ? response.value : [];
			setRows(mapRows(list));
			setColumns([
				{ Header: "Tipo de Identificación", accessor: "tipoIdentificacion", align: "left" },
				{ Header: "Activo", accessor: "activo", align: "center" },
				{ Header: "Acciones", accessor: "action", align: "center" },
			]);
			setRefreshKey(k => k + 1);
		} catch (ex) {
			console.error("Error cargando SujetoTipoIdentificacion:", ex);
			setError(ex);
		}
	};

	const handleAskDelete = (id) => { setDeleteId(id); setOpenDelete(true); };
	const handleCancelDelete = () => { setOpenDelete(false); setDeleteId(null); };

	const delay = (ms) => new Promise((res) => setTimeout(res, ms));

	const handleConfirmDelete = async () => {
		if (!deleteId) return;
		try {
			setDeleting(true);
			const res = await deleteData(`/SujetoTipoIdentificacionDelete/${deleteId}`);
			if (res?.isSuccess) {
				setSnackbar({ open: true, msg: 'Tipo de identificación eliminado', severity: 'success' });
				// Optimista: sacar la fila localmente
				setRows((prev) => prev.filter((r) => r.id !== deleteId));
				// Verificar en backend hasta que el id no aparezca
				const maxAttempts = 6;
				const intervalMs = 500;
				for (let attempt = 1; attempt <= maxAttempts; attempt++) {
					const resp = await getData("/SujetoTipoIdentificacionListar");
					const latest = Array.isArray(resp?.value) ? resp.value : [];
					const stillPresent = latest.some((x) => x.idSujetoTipoIdentificacion === deleteId);
					if (!stillPresent) {
						setRows(mapRows(latest));
						setRefreshKey((k) => k + 1);
						break;
					}
					if (attempt < maxAttempts) await delay(intervalMs);
					else {
						setRows(mapRows(latest));
						setRefreshKey((k) => k + 1);
					}
				}
			} else {
				setSnackbar({ open: true, msg: res?.error || 'No se pudo eliminar', severity: 'error' });
			}
		} catch (ex) {
			const msg = ex?.detail || ex?.message || 'No se pudo eliminar';
			setSnackbar({ open: true, msg, severity: 'error' });
		}
		setOpenDelete(false); setDeleteId(null); setDeleting(false);
	};
	const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox pt={6} pb={3}>
				<Grid container spacing={6}>
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={3}
								px={2}
								variant="gradient"
								bgColor="secondary"
								borderRadius="lg"
								coloredShadow="light"
								display="flex"
								justifyContent="space-between"
								alignItems="center"
							>
								<MDTypography variant="h6" color="white">
									Tipos de Identificación
								</MDTypography>
								<ManualAyuda seccion="Tipo de Identificación" />
							</MDBox>

							<MDBox pt={3} py={3} px={2}>
								<MDButton
									onClick={handleAdd}
									variant="gradient"
									color="success"
									endIcon={<BuildingFillAdd />}
								>
									Agregar
								</MDButton>

								<DataTable
									key={refreshKey}
									table={{ columns, rows }}
									isSorted={false}
									showTotalEntries
									canSearch={false}
									noEndBorder
									pagination={{ color: "info", variant: "gradient" }}
								/>

								<Dialog open={openDelete} onClose={handleCancelDelete}>
									<DialogTitle>Confirmar eliminación</DialogTitle>
									<DialogContent>
										¿Seguro que deseas eliminar este Tipo de Identificación? 🗑️
									</DialogContent>
									<DialogActions>
										<MDButton variant="text" color="dark" onClick={handleCancelDelete}>Cancelar</MDButton>
										<MDButton variant="gradient" color="error" onClick={handleConfirmDelete} disabled={deleting}>Eliminar</MDButton>
									</DialogActions>
								</Dialog>

								<Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
									<MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">{snackbar.msg}</MuiAlert>
								</Snackbar>
							</MDBox>
						</Card>
					</Grid>
				</Grid>
			</MDBox>
		</DashboardLayout>
	);
}

export default SujetoTipoIdentificacionList;
